import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    disableInput: Boolean,
    disableEverything: Boolean,
  };

  // Fields kept editable by id even while the rest of the form is disabled.
  static editableIds = ["bank_detail_iban", "bank_detail_bic", "bank_detail_name", "bank_detail_account_holder"];

  connect() {
    if (!this.disableInputValue) return;

    let formElements;
    if (window.location.pathname.includes("/rights")) {
      formElements = document.querySelectorAll(
        "#nettowelt_configuration_agent_attributes_agent_group_id"
      );
    } else if (this.disableEverythingValue) {
      formElements = document.querySelectorAll("input, select, textarea");
    } else {
      // Exempting by container (not just the visible field's id) also covers
      // that field's own hidden inputs (e.g. Rails' "_method" override), which
      // would otherwise be disabled too and silently dropped from the submit.
      formElements = Array.from(document.querySelectorAll("input, select, textarea")).filter(
        (element) =>
          !this.constructor.editableIds.includes(element.id) && !element.closest("[data-input-disable-exempt]")
      );
    }

    formElements.forEach(function (element) {
      element.setAttribute("disabled", true);
      element.style.cursor = "not-allowed";
      const label = document.querySelector("label[for='" + element.id + "']");
      if (label) {
        label.style.cursor = "not-allowed";
      }
    });
  }
}
